module.exports = __webpack_public_path__ + "static/media/brochures.6fb5e93c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Layout/Features/brochures.jpg
// module id = 1017
// module chunks = 2